// Copyright (c) 2017 Comsearch, Inc., All rights reserved

const cleanComment = (c, uniqueId) => {
  const {
    attachments,
    comment,
    createTimestamp,
    createUser,
  } = c

  return {
    [uniqueId]: c[uniqueId],
    attachments,
    createTimestamp,
    comment,
    createUser: createUser.userName,
    createUserId: createUser.userId,
    uniqueId,
  }
}

export default cleanComment
